export default function IconInfo({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M12 1.85693C5.92487 1.85693 1 6.7818 1 12.8569C1 18.9321 5.92487 23.8569 12 23.8569C18.0751 23.8569 23 18.9321 23 12.8569C23 6.7818 18.0751 1.85693 12 1.85693ZM12 3.85693C16.9706 3.85693 21 7.88637 21 12.8569C21 17.8275 16.9706 21.8569 12 21.8569C7.02944 21.8569 3 17.8275 3 12.8569C3 7.88637 7.02944 3.85693 12 3.85693ZM12 11.8569C11.4477 11.8569 11 12.3046 11 12.8569V16.8569C11 17.4092 11.4477 17.8569 12 17.8569C12.5523 17.8569 13 17.4092 13 16.8569V12.8569C13 12.3046 12.5523 11.8569 12 11.8569ZM11.9902 7.85693L11.8877 7.86182C11.3835 7.91304 10.9902 8.33918 10.9902 8.85693C10.9902 9.37469 11.3835 9.80083 11.8877 9.85205L11.9902 9.85693H12C12.5523 9.85693 13 9.40922 13 8.85693C13 8.30465 12.5523 7.85693 12 7.85693H11.9902Z"
                fill="currentColor"
            />
        </svg>
    );
}
